import { render, staticRenderFns } from "./VesselList.vue?vue&type=template&id=52ad1488&scoped=true"
import script from "./VesselList.vue?vue&type=script&lang=js"
export * from "./VesselList.vue?vue&type=script&lang=js"
import style0 from "./VesselList.vue?vue&type=style&index=0&id=52ad1488&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad1488",
  null
  
)

export default component.exports